import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=9fb54c7c"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports